import React from 'react';

// StatCard Component
const StatCard = ({ title, value, change, icon, color, darkMode = false }) => {
    // Safe defaults
    const safeTitle = title || "No Title";
    const safeValue = value !== undefined ? value : "0";
    const safeChange = change || "";
    const safeIcon = icon || "bi bi-briefcase";
    const safeColor = color || "primary";

    // Map to light bg classes
    const bgLightClass = `bg-${safeColor} bg-opacity-10`;

    return (
        <>
            <div className={`card stat-card h-100 border-0 shadow-sm ${bgLightClass}`}>
                <div className="card-body d-flex align-items-center">
                    {/* Icon on left, 40% width */}
                    <div
                        className={`text-${safeColor} d-flex justify-content-center align-items-center`}
                        style={{ flex: "0 0 40%", fontSize: "3.5rem" }}
                    >
                        <i className={`bi ${safeIcon}`}></i>
                    </div>

                    {/* Text on right, 60% width */}
                    <div className="ms-3" style={{ flex: "0 0 60%" }}>
                        <h6 className="text-muted mb-1">{safeTitle}</h6>
                        <h3 className="fw-bold mb-1">{safeValue}</h3>
                        <small className={darkMode ? "text-light" : "text-muted"}>{safeChange}</small>
                    </div>
                </div>
            </div>
            {/* Custom CSS */}
            <style>{`
                .hover-scale {
                  transition: transform 0.2s ease, box-shadow 0.2s ease;
                }
                .hover-scale:hover {
                  transform: translateY(-3px);
                  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.1);
                }
                .stat-card {
                  transition: transform 0.3s ease, box-shadow 0.3s ease;
                }
                .stat-card:hover {
                  transform: translateY(-5px);
                  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.15);
                }
            `}</style>
        </>
    );
};

export default StatCard;
